export default "__VITE_ASSET__CGMRYlV3__"